define('app-Search/settings',[],function () {
    return {
        // selectors
        container: "#searchControl",
        searchSummary: "#searchSummary",
        searchTabs: "#searchTabs",

        // ajax calls
        productSearchUrl: window.location.protocol + "//" + window.location.host + "/findbyproductcode/get",
        departurePointsDropdownUrl: window.location.protocol + "//" + window.location.host + "/searchresults/getdeparturepointsdropdown",
        destinationDropdownUrl: window.location.protocol + "//" + window.location.host + "/searchresults/getdestinationdropdown",
        facetsForUrl: window.location.protocol + "//" + window.location.host + "/searchresults/getfacetsfor",
        getHostsUrl: window.location.protocol + "//" + window.location.host + "/searchservice/gethosts",
        indexUrl: window.location.protocol + "//" + window.location.host + "/searchservice/index",
        matchesForUrl: window.location.protocol + "//" + window.location.host + "/searchservice/matchesfor",
        resultCountUrl: window.location.protocol + "//" + window.location.host + "/searchservice/getresultcount",
        getResultsUrl: window.location.protocol + "//" + window.location.host + "/searchservice/getresults",
        oceanSearchData: window.location.protocol + "//" + window.location.host + "/cruisesearch/getoceansearchdata",
        riverSearchData: window.location.protocol + "//" + window.location.host + "/cruisesearch/getriversearchdata",

        // other
        searchStorageKey: "searchControl",
        searchUrlKey: "app-Search-Tags",
        pagePositionKey: "app-Search-PagePosition",
        jumbotronWithSearch: ".jumbotron__container .row #searchControl",
        groupNavWithSearch: "#searchMobile #searchControl"
    };
});
